import mainCaller from './mainCaller';
const qs = require('qs');

export const checkUsernameDuplicate = async (username, token) => {
  return await mainCaller(`admin/api/v1/employees/check-username?username=${encodeURIComponent(username)}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
};

export const checkPhoneNumberDuplicate = async (phoneNumber, token) => {
  return await mainCaller(`admin/api/v1/employees/check-phone?phoneNumber=${encodeURIComponent(phoneNumber)}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
};

export const createStaff = async (data, token) => {
  return await mainCaller('admin/api/v1/employees', 'POST', data, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'multipart/form-data',
  });
};

export const updateStaff = async (data, token, id) => {
  return await mainCaller(`admin/api/v1/employees/${id}`, 'PUT', data, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'multipart/form-data',
  });
};

export const getAllStaffs = async (token, query) => {
  return await mainCaller(`admin/api/v1/employees?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
};

export const getEmployeeIdMembers = async (token, id, query) => {
  const queryString = query ? `?${qs.stringify(query)}` : '';
  return await mainCaller(`admin/api/v1/employees/${id}/members${queryString}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
};

export const getStaffById = async (id, token, branchId) => {
  const query = branchId ? `?branchId=${branchId}` : '';
  return await mainCaller(`admin/api/v1/employees/${id}${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
};

export const deleteStaffById = async id => {
  return await mainCaller(`api/deleteUserAdminka/${id}`, 'GET', null, {});
};

export const getTrainers = async (query, token) => {
  return await mainCaller(`admin/getAllTrainers?${qs.stringify(query)}`, 'GET', null, {
    Authorization: 'Bearer ' + token,
  });
};

export const getPointTrainers = async (id, token) => {
  return await mainCaller(`admin/api/v1/search-options/branch-trainers?branchId=${id}`, 'GET', null, {
    Authorization: 'Bearer ' + token,
  });
};

// 강사 표시 순서 변경 (배열 순서대로 sortOrder 부여)
export const updateBranchTrainerOrder = async (branchId, trainerIds, token) => {
  return await mainCaller(
    `admin/api/v1/branches/${branchId}/trainers/order`,
    'PUT',
    { trainerIds },
    { Authorization: 'Bearer ' + token },
  );
};

export const getBranchManager = async (id, token) => {
  return await mainCaller(`admin/api/v1/search-options/branch-manager?branchId=${id}`, 'GET', null, {
    Authorization: 'Bearer ' + token,
  });
};

export const getEmployeeAttendHistories = async (token, query) => {
  return await mainCaller(`admin/api/v1/employees/attend-histories?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
};

// export const getEmployeeAttendHistories = async (token, query) => {
//   return await mainCaller(`admin/api/v1/employees/attend-histories/${query}`, 'GET', null, {
//     Authorization: `Bearer ${token}`,
//   });
// };

// ============================================
// 임직원 다지점 관리
// ============================================

export const searchEmployeesForBranch = async (keyword, token) => {
  return await mainCaller(`admin/api/v1/employee-branches/search?keyword=${encodeURIComponent(keyword)}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
};

export const getEmployeesByBranch = async (branchId, token) => {
  return await mainCaller(`admin/api/v1/employee-branches?branchId=${branchId}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
};

export const addEmployeeToBranch = async (data, token) => {
  return await mainCaller('admin/api/v1/employee-branches', 'POST', data, {
    Authorization: `Bearer ${token}`,
  });
};

export const removeEmployeeFromBranch = async (id, token) => {
  return await mainCaller(`admin/api/v1/employee-branches/${id}`, 'DELETE', null, {
    Authorization: `Bearer ${token}`,
  });
};
